import script from "./Feedback.vue?vue&type=script&setup=true&lang=ts"
export * from "./Feedback.vue?vue&type=script&setup=true&lang=ts"

import "./Feedback.vue?vue&type=style&index=0&id=68ba2463&lang=scss&scoped=true"

import exportComponent from "/opt/tiger/compile_path/src/code.byted.org/ad/se_tt4b_academy_advertiser_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68ba2463"]])

export default __exports__